// extracted by mini-css-extract-plugin
export default {"form":"UpdatePassword_form__WGMtK","button":"UpdatePassword_button__c7Gbr"};